<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Carousel" pageTitle="Carousel" />
            <CarouselContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import CarouselContent from '../Carousel/CarouselContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'CarouselPage',
    components: {
        MainHeader,
        PageTitle,
        CarouselContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>